import { createFileRoute, redirect } from "@tanstack/react-router"

import { AvatarFallbacksDemoPage } from "@/pages/dev/avatar-fallbacks-demo"

export const Route = createFileRoute("/_authenticated/settings/dev/demos/avatar-fallbacks")({
  beforeLoad: () => {
    if (!import.meta.env.DEV) {
      throw redirect({ to: "/dashboard" })
    }
  },
  component: AvatarFallbacksDemoPage,
})
